<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            heading: "Exceptions de fermeture et d'ouverture",
            edit: "Modifier",
            holiday_label: "Jours fériés",
            holiday_valueClosed: "Fermé pendant les jours fériés",
            holiday_valueOpen: "Ouvert pendant les jours fériés",
            vacancy_label: "Vacances scolaires",
            vacancy_valueClosed:
                "Zone {zone} • Fermé pendant les vacances scolaires",
            vacancy_valueOpen:
                "Zone {zone} • Ouvert pendant les vacances scolaires",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = withDefaults(
    defineProps<{
        /** Fermé les jours fériés */
        holiday?: boolean
        /** Fermé pendant les vacances scolaires */
        vacancy?: boolean
        /** Zone scolaire (A, B, C) */
        zone?: string
        /** Mode lecture seule */
        readonly?: boolean
    }>(),
    { holiday: false, vacancy: false, zone: "", readonly: false }
)

defineEmits<{ "click:edit": [] }>()

// ================================
// DONNÉES CALCULÉES
// ================================
/** Lignes formatées pour l'affichage */
const getLines = computed(() => [
    {
        label: t("holiday_label"),
        value: props.holiday
            ? t("holiday_valueClosed")
            : t("holiday_valueOpen"),
    },
    {
        label: t("vacancy_label"),
        value: props.vacancy
            ? t("vacancy_valueClosed", { zone: props.zone || "-" })
            : t("vacancy_valueOpen", { zone: props.zone || "-" }),
    },
])
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT -->
    <!-- ================================ -->
    <div class="usage-profile-item-exception">
        <UsageProfileItemField
            class="usage-profile-item-exception__header min-h-10 px-3 border-b border-gray-200"
            :label="t('heading')"
            label-class="text-primary-700! text-base! font-semibold!"
        >
            <BaseButton
                v-if="!readonly"
                :label="t('edit')"
                size="small"
                text
                @click="$emit('click:edit')"
            />
        </UsageProfileItemField>
        <UsageProfileItemField
            v-for="(line, index) in getLines"
            :key="index"
            class="border-b border-gray-200 hover:bg-primary-100"
            :value="line.value"
            :label="line.label"
        />
    </div>
</template>
